var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "21px",
    viewBox: "0 0 15 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cost") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "April-2020---Calculator-Solutions,-Skip-Hire-Header-Variations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skip-Hire-Header-Variation-3",
    transform: "translate(-286.000000, -368.000000)",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300,388 L300,384.895593 L292.006591,384.895593 C292.512555,384.268701 292.765537,383.427119 292.765537,382.370847 L292.765537,382.370847 L292.69209,380.580339 L296.364407,380.580339 L296.364407,377.540339 L292.581921,377.540339 L292.471751,374.616271 C292.471751,373.791864 292.649247,373.169266 293.004237,372.748475 C293.359228,372.327684 293.806026,372.117288 294.344633,372.117288 C295.00565,372.117288 295.513653,372.310508 295.868644,372.696949 C296.223635,373.08339 296.40113,373.641582 296.40113,374.371525 L296.40113,374.371525 L299.914313,374.371525 C299.914313,372.722712 299.42059,371.415254 298.433145,370.449153 C297.4457,369.483051 296.086943,369 294.356874,369 C292.667608,369 291.319052,369.502373 290.311205,370.507119 C289.303358,371.511864 288.799435,372.881582 288.799435,374.616271 L288.799435,374.616271 L288.885122,377.540339 L287,377.540339 L287,380.580339 L288.983051,380.580339 L289.044256,382.589831 C289.044256,383.972429 288.750471,384.741017 288.1629,384.895593 L288.1629,384.895593 L287.036723,384.895593 L287.036723,388 L300,388 Z",
    id: "Cost"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCost);
export default __webpack_public_path__ + "static/media/cost.f7827836748f47e278c70eaaf6d11a68.svg";
export { ForwardRef as ReactComponent };